import { ROUTES } from '../constants/routes.constants';

/**
 * Detecta se o browser é Safari (inclui iOS Safari).
 * Usado para decidir entre página de redirecionamento (Safari) e dialog (outros).
 */
export function isSafariBrowser(): boolean {
  if (typeof navigator === 'undefined') return false;
  const ua = navigator.userAgent;
  const isSafari = /safari/i.test(ua) && !/chrome|crios|fxios|opios|edg/i.test(ua);
  const isIos = /iphone|ipad|ipod/i.test(ua);
  return !!(isSafari || (isIos && !/crios|fxios|opios|edg/i.test(ua)));
}

/**
 * Monta a URL da página de redirecionamento (#/redirect?url=...&countdown=...).
 * Usada no Safari para abrir em nova aba no gesto do usuário (evita bloqueio de popup).
 */
export function getCarrotRedirectPageUrl(targetUrl: string, countdown: number = 10): string {
  const base = window.location.origin + window.location.pathname;
  const hash = `#${ROUTES.REDIRECT}?url=${encodeURIComponent(targetUrl)}&countdown=${countdown}`;
  return `${base}${hash}`;
}

/**
 * Abre a página de redirecionamento do pacote cenoura em nova aba (mesmo origem).
 * Deve ser chamado de forma síncrona no handler do clique (sem await antes desta chamada)
 * para que o Safari iOS considere o gesto do usuário e não bloqueie a nova aba.
 */
export function openCarrotRedirectInNewTab(targetUrl: string, countdown: number = 10): void {
  const url = getCarrotRedirectPageUrl(targetUrl, countdown);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.target = '_blank';
  anchor.rel = 'noopener noreferrer';
  anchor.style.display = 'none';
  document.body.appendChild(anchor);
  anchor.click();
  document.body.removeChild(anchor);
}

/**
 * Abre uma URL em nova aba de forma compatível com browsers mobile.
 * Usa âncora com target="_blank" no mesmo gesto do usuário para evitar bloqueio de popup.
 */
export function openUrlInNewTab(url: string): void {
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.target = '_blank';
  anchor.rel = 'noopener noreferrer';
  anchor.style.display = 'none';
  document.body.appendChild(anchor);
  anchor.click();
  document.body.removeChild(anchor);
}
